import { PropsWithChildren } from 'react'

import { useCreation } from 'ahooks'

import { DeptUserBaseStoreContext } from './contexts/StoreContext'
import { DeptUserBaseStoreProviderProps } from './interface'
import { createDeptUserBaseStore } from './store/createStore'
import { DeptUserBaseStoreUpdater } from './StoreUpdater'

export const DeptUserBaseStoreProvider = <M extends boolean>({
  children,
  /* -------------------------------------------------------------------------- */
  /*                       DeptUserBaseStoreUpdater Props                       */
  /* -------------------------------------------------------------------------- */
  strictMode,
  multiple,
  triggerChangeWhenSelect,
  value,
  onChange
}: PropsWithChildren<DeptUserBaseStoreProviderProps<M>>) => {
  const store = useCreation(() => createDeptUserBaseStore(), [])
  return (
    <DeptUserBaseStoreContext value={store}>
      <DeptUserBaseStoreUpdater
        multiple={multiple}
        strictMode={strictMode}
        triggerChangeWhenSelect={triggerChangeWhenSelect}
        value={value}
        onChange={onChange}
      />
      {children}
    </DeptUserBaseStoreContext>
  )
}
